var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { padding: "0", overflow: "visible" } },
            [
              _c("u-connect-direct-registration"),
              _vm._v(" "),
              _c("u-connect-select-plan-details-step"),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { staticClass: "step-row" },
                        [
                          _c(
                            "el-col",
                            { staticClass: "step-title", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Step 1")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "step-desc", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Create account")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "step-row" },
                        [
                          _c(
                            "el-col",
                            { staticClass: "step-title", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Step 2")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "step-desc", attrs: { span: 24 } },
                            [
                              _c("span", [
                                _vm._v("Explore off-the-plan property listings")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "step-row" },
                        [
                          _c(
                            "el-col",
                            { staticClass: "step-title", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Step 3")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "step-desc", attrs: { span: 24 } },
                            [
                              _c("span", [
                                _vm._v(
                                  "Submit your client referral to our Concierge Service"
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "step-row" },
                        [
                          _c(
                            "el-col",
                            { staticClass: "step-title", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Step 4")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "step-desc", attrs: { span: 24 } },
                            [
                              _c("span", [
                                _vm._v(
                                  "Receive reward benefits upon successful sales"
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "step-row" },
                        [
                          _c(
                            "el-col",
                            { staticClass: "step-title", attrs: { span: 24 } },
                            [_c("span", [_vm._v("Step 5")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "step-desc", attrs: { span: 24 } },
                            [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v("Repeat!")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06547cc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06547cc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectRegistrationLayout.vue
// module id = null
// module chunks = 